import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { FlowConsignadoListResponseDTO } from 'pages/consignado/list/consignado-list.model';
import { theme } from 'theme';
import { currencyOf } from 'utils/util';

type Props = {
    itens: FlowConsignadoListResponseDTO[];
};

const ConsignadoEmAndamentoDialog = (props: Props) => {
    return (
        <>
            <Typography>Cliente possui consignado em andamento.</Typography>
            <TableContainer
                sx={{
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 1,
                    position: 'relative',
                    boxSizing: 'border-box',
                    maxHeight: '400px',
                    padding: '5px',
                }}
            >
                <Table id="consignado-em-andamento-table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nº</TableCell>
                            <TableCell>Emissão</TableCell>
                            <TableCell>Situação</TableCell>
                            <TableCell>Valor em aberto</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.itens.map(item => (
                            <TableRow key={item.uuid}>
                                <TableCell>{item.ordem}</TableCell>
                                <TableCell>{item.emissao}</TableCell>
                                <TableCell>{item.situacao}</TableCell>
                                <TableCell>{currencyOf(item.valorAberto)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default ConsignadoEmAndamentoDialog;
